import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

export default {
  uploadImage: ac<{ id: number; data: FormData }>('uploadImage'),
  clearState: ac('clearState'),
  uploadQuestionImage: ac<{ file: FormData; id: number; groupId: number; step: number; record: any }>(
    'uploadQuestionImage',
  ),
  imageUploadedSuccess: ac<{ recordId: string; name: string }>('imageUploadedSuccess'),
};
